(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LanguageDialogController', LanguageDialogController);

    LanguageDialogController.$inject = ['$scope', '$stateParams', '$mdDialog', 'entity', 'Language'];

    function LanguageDialogController ($scope, $stateParams, $mdDialog, entity, Language) {
        var vm = this;
        vm.language = entity;
        vm.load = function(id) {
            Language.get({id : id}, function(result) {
                vm.language = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('atheer:languageUpdate', result);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.language.id !== null) {
                Language.update(vm.language, onSaveSuccess, onSaveError);
            } else {
                Language.save(vm.language, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $mdDialog.cancel();
        };
    }
})();
